// buildEntries.ts - Enhanced version
import type { ParsedFileResult } from './types';

export type ColumnMapping = Record<string, string>;

export function buildEntries(parsed: ParsedFileResult, mapping: ColumnMapping) {
  const { vendorName, headers, rows } = parsed;
  const entries: any[] = [];

  // is vendor mapped explicitly by a column header?
  const vendorMappedByHeader = Object.values(mapping).includes('vendorName');

  rows.forEach((rowArr, rowIndex) => {
    const entry: any = {
      vendorName: vendorMappedByHeader ? undefined : (vendorName || undefined),
      status: 'active',
      description: { text: '', jsonFields: {} },
    };

    // iterate by column index to keep alignment
    headers.forEach((colHeader, colIndex) => {
      const mapped = mapping[colHeader];
      const rawValue = rowArr[colIndex] ?? '';

      // Skip if both mapped field and raw value are empty
      if (!mapped && !rawValue) return;

      if (!mapped || mapped === '') {
        // unmapped -> store using header as key inside jsonFields
        if (rawValue) {
          entry.description.jsonFields[colHeader] = rawValue;
        }
        return;
      }

      if (mapped === '__extra') {
        if (rawValue) {
          entry.description.jsonFields[colHeader] = rawValue;
        }
        return;
      }

      if (mapped === 'descriptionText') {
        entry.description.text = rawValue;
        return;
      }

      if (mapped === 'vendorName') {
        entry.vendorName = rawValue || vendorName || undefined;
        return;
      }

      if (['mrp', 'purchasePrice'].includes(mapped)) {
        // Enhanced number parsing for CSV
        const cleanValue = String(rawValue).replace(/[^0-9.-]/g, '');
        const n = cleanValue ? Number(cleanValue) : NaN;
        entry[mapped] = Number.isFinite(n) ? n : undefined;
      } else {
        entry[mapped] = rawValue !== '' ? rawValue : undefined;
      }
    });

    // Only add entry if it has at least some data
    if (entry.vendorName || entry.partNo || entry.productName || Object.keys(entry.description.jsonFields).length > 0 || entry.description.text) {
      entries.push(entry);
    }
  });

  return entries;
}